import comp from "./CreateParentAccount";
export default comp;
